import { render, staticRenderFns } from "./FormImage.vue?vue&type=template&id=2c611162&"
import script from "./FormImage.vue?vue&type=script&lang=js&"
export * from "./FormImage.vue?vue&type=script&lang=js&"
import style0 from "./FormImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports